module.exports = __webpack_public_path__ + "img/ampulheta.3bcd9e37.png";